<template>
  <span v-bind="$attrs" class="subtitle-2 black--text">
    {{ totalEntries }} of {{ total }} Entries
  </span>
</template>

<script>
import { DEFAULT_PAGE_SIZE } from '@/utils/constants'

export default {
  name: 'TotalEntriesCount',

  props: {
    /** Current page number */
    page: {
      type: Number,
      required: true,
    },
    /** Total number of items */
    total: {
      type: Number,
      required: true,
    },
    /** Total items per page */
    itemsPerPage: {
      type: Number,
      required: false,
      default: DEFAULT_PAGE_SIZE,
    },
  },

  computed: {
    totalEntries() {
      const { page, total, itemsPerPage } = this

      return page * itemsPerPage > total ? total : page * itemsPerPage
    },
  },
}
</script>

<style lang="scss" scoped>
/** Overrides the 'capitalize' styling applied by the table header */
span {
  text-transform: none;
}
</style>
